import * as React from 'react';

function SvgSpotifyColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="SpotifyColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={2}
        y={2}
        width={26}
        height={27}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2.155h25.917v25.917H2V2.155z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#SpotifyColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.917 15.113c0 7.157-5.802 12.959-12.959 12.959C7.803 28.072 2 22.27 2 15.113 2 7.957 7.802 2.155 14.959 2.155c7.156 0 12.958 5.802 12.958 12.958z"
          fill="#53B95F"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.161 21.278c-.15 0-.3-.04-.438-.122-5.103-3.07-11.152-1.294-11.212-1.276a.852.852 0 01-.497-1.628c.276-.085 6.82-2.023 12.587 1.445a.851.851 0 01-.44 1.58zM21.628 17.783a1 1 0 01-.501-.134c-6.41-3.687-12.869-1.54-12.933-1.518a1.006 1.006 0 01-.653-1.904c.299-.102 7.395-2.459 14.589 1.678a1.006 1.006 0 01-.502 1.878zM23.22 13.817a1.23 1.23 0 01-.575-.142c-7.39-3.881-14.98-1.557-15.055-1.534a1.238 1.238 0 11-.745-2.36c.35-.111 8.659-2.654 16.952 1.702a1.238 1.238 0 01-.577 2.334z"
        fill="#FEFEFE"
      />
    </svg>
  );
}

export default SvgSpotifyColour;
